module.exports = __webpack_public_path__ + "static/grant_customer_access_form-05c485548910947ef787c0c3208f2af2.png";